import { action, computed, observable } from 'mobx';
import { PremiumSessionCollateral } from 'types/premiumSession';

import UIStore from 'stores/UI';
import UserStore from 'stores/User';
import { getPremiumSessionCollateral } from 'services/PremiumSessionService';

class PremiumLandingStore {
  @observable isLoading = true;

  @observable isDataLoaded = false;

  @observable sessionSlug: string = null;

  @observable coursePremiumSessionCollateral: PremiumSessionCollateral = null;

  @observable languageOverride: string;

  @observable isError = false;

  uiStore: UIStore;

  userStore: UserStore;

  constructor(uiStore: UIStore, userStore: UserStore) {
    this.uiStore = uiStore;
    this.userStore = userStore;
  }

  @computed get language() {
    return this.languageOverride || this.uiStore.currentLanguage || 'en-US';
  }

  @computed get title() {
    return this.coursePremiumSessionCollateral?.offering_title ?? null;
  }

  @action fetchOverviewData = async (slug: string) => {
    try {
      this.isError = false;
      this.isLoading = true;
      this.sessionSlug = slug;

      const sessionSlug = `${slug}-s01`;

      const coursePremiumSessionCollateral = await getPremiumSessionCollateral(
        sessionSlug,
        this.language,
        true,
        'en-US',
      );

      this.coursePremiumSessionCollateral = coursePremiumSessionCollateral;
      this.isDataLoaded = true;
      this.isLoading = false;
    } catch (err) {
      this.isError = true;
      this.isLoading = false;

      throw new Error(err);
    }
  };

  @action externalLoadingError = () => {
    if (!this.isError) {
      this.isError = true;
      this.isDataLoaded = false;
      this.isLoading = false;
    }
  };
}

export default PremiumLandingStore;
